export default "__VITE_PUBLIC_ASSET__b498e543__"